/**
 * Thrown when an RRULE string is structurally invalid or violates a semantic
 * constraint of the supported subset (unparseable, `COUNT < 1`, both `COUNT` and
 * `UNTIL` set, malformed `UNTIL`). Framework-agnostic so consumers can
 * translate it to their own error type.
 */
export class RecurrenceConfigError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RecurrenceConfigError';
  }
}

/**
 * Thrown when an RRULE requests a `FREQ` the engine does not (yet) support.
 * The engine supports `MONTHLY` and `YEARLY`; `WEEKLY`/`DAILY` and others throw this.
 */
export class UnsupportedFrequencyError extends Error {
  constructor(
    readonly freq: string,
    message: string
  ) {
    super(message);
    this.name = 'UnsupportedFrequencyError';
  }
}
